import { NEXT_PUBLIC_ADMIN_APP_URL } from "@/lib/config/env";
import { tokenStorage } from "@/lib/utils/tokenStorage";
import type { User } from "@/types/auth-types";

type AdminRedirectParams = {
  refreshJti?: string | null;
  refreshToken?: string | null;
  user: Pick<User, "id" | "role">;
};

export function isAdminUser(user: Pick<User, "role"> | null | undefined) {
  return user?.role === "ADMIN";
}

export function buildAdminPortalLoginUrl({
  refreshJti,
  refreshToken,
  user,
}: AdminRedirectParams) {
  const baseUrl =
    NEXT_PUBLIC_ADMIN_APP_URL || "https://admin.snappy-fix.com/login";
  const url = new URL(baseUrl);

  if (refreshJti) {
    url.searchParams.set("refresh_jti", refreshJti);
  }

  if (refreshToken) {
    url.searchParams.set("refresh_token", refreshToken);
  }

  url.searchParams.set("user_type", user.role);
  url.searchParams.set("id", user.id);

  return url.toString();
}

export function redirectToAdminPortal(params: AdminRedirectParams) {
  if (typeof window === "undefined") {
    return;
  }

  window.location.href = buildAdminPortalLoginUrl(params);
}

export function redirectStoredAdminToPortal(user: User) {
  redirectToAdminPortal({
    refreshJti: tokenStorage.getRefreshJti(),
    refreshToken: tokenStorage.getRefreshToken(),
    user,
  });
}
